import { CriteriaType } from "@stw/yup-validators";

export const criteriaTypeToLabel: Record<CriteriaType, string> = {
  VARIANT_REACHED_MIN_ROI: "",
  FIRST_TO_MIN_ROI: "Which variant reaches a minimum ROI first",
  HIGHEST_ROI_AT_TIME: "Which variant has a higher ROI at a set time",
};
